import React, { Component } from 'react';
import PropTypes from 'prop-types';
import competencyIcons from './../../../../../../style/competencyicons/competencyicons.scss';
import Developability from '../../../Developability';
import style from './style/competencyicon.scss';

class CompetencyIcon extends Component {
    render() {
        const { handle, developabilityLabel, developabilityScore } = this.props;

        if (!handle) {
            return null;
        }

        return <div className={ `${style.icon_competency} ${style[handle]}` }>
            <figure>
                <i className={ `${competencyIcons.icon} ${competencyIcons[handle]}` } />
                {developabilityScore
                    ? <Developability
                        developabilityLabel={developabilityLabel}
                        developabilityScore={developabilityScore}
                        classes={{
                            root: style.badge_developability
                        }}
                    />
                    : null}
            </figure>
        </div>;
    }
}

export default CompetencyIcon;

CompetencyIcon.propTypes = {
    handle: PropTypes.string,
    developabilityLabel: PropTypes.string,
    developabilityScore: PropTypes.string
};
